/**
 * Attaches a verified Firebase ID token to backend API calls. Every call to
 * the FastAPI backend's auth-gated endpoints (/analyze, /aero-insights,
 * /coach, /entities, /coaching_relationships, /teams/*, /my-entities) needs
 * this -- see app/core/auth.py's require_auth on the backend side.
 */
import { auth } from '@/js/firebase'

export async function authenticatedFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const token = await auth.currentUser?.getIdToken()
  if (!token) {
    throw new Error('Not signed in.')
  }

  return fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: `Bearer ${token}`
    }
  })
}
